import axios from 'axios';
import { fromUserDto } from '../../mappers/users/toUserModel';
import type { UserDataModel } from './types';

export async function loadUser(userId: string): Promise<UserDataModel> {
    const response = await axios.get(`/user/${userId}`);

    return fromUserDto({ ...response.data, id: userId });
}
